export const getHost = () => {
  let server = window.location.host;
  // if (server === 'localhost:8090' || process.env.NODE_ENV === 'development') {
  if (server === 'localhost:8090') {
    return 'devp23.io.land';
  }
  return server;
};
